export function LoadingGlobeFallback() {
  return (
    <>
      <style>{loadingGlobeFallbackCss}</style>
      <div aria-hidden="true" className="fintheon-loading-globe-fallback">
        <div className="fintheon-loading-globe-fallback__core" />
      </div>
    </>
  );
}

const loadingGlobeFallbackCss = `
  .fintheon-loading-globe-fallback {
    position: absolute;
    z-index: 0;
    inset: 0;
    overflow: hidden;
    opacity: 0.72;
    pointer-events: none;
    -webkit-mask-image: radial-gradient(circle at center, #000 0 51%, rgba(0, 0, 0, 0.72) 66%, transparent 88%);
    mask-image: radial-gradient(circle at center, #000 0 51%, rgba(0, 0, 0, 0.72) 66%, transparent 88%);
  }

  .fintheon-loading-globe-fallback__core {
    position: absolute;
    top: 50%;
    left: 50%;
    width: min(50vmin, 520px);
    aspect-ratio: 1;
    border-radius: 999px;
    transform: translate(-50%, -50%);
    background:
      radial-gradient(circle at 34% 29%, color-mix(in srgb, var(--fintheon-primary, var(--fintheon-accent)) 22%, transparent) 0 0.8%, transparent 1.2%),
      radial-gradient(circle at 63% 48%, color-mix(in srgb, var(--fintheon-primary, var(--fintheon-accent)) 19%, transparent) 0 0.65%, transparent 1.1%),
      radial-gradient(circle at 47% 68%, color-mix(in srgb, var(--fintheon-primary, var(--fintheon-accent)) 16%, transparent) 0 0.55%, transparent 1%),
      radial-gradient(circle at center, color-mix(in srgb, var(--fintheon-primary, var(--fintheon-accent)) 14%, transparent) 0 26%, transparent 68%);
  }

  @media (prefers-reduced-motion: reduce) {
    .fintheon-loading-globe-fallback { transition: none; }
  }
`;
